export default "__VITE_ASSET__DnbdrCOi__"